import { defineNuxtRouteMiddleware} from "nuxt/app";
import { useTopbarFilterStore } from "@/store/topbarFilterStore";
import { useQuickFilterStore } from "@/store/quickFilterStore";
import { DEFAULT_FILTER_STATE } from "@/constants/filter";

export default defineNuxtRouteMiddleware(async (to) => {
  const filterStore = useTopbarFilterStore();
  const quickFilterStore = useQuickFilterStore();

  let viewId = undefined;

  // Get and set filter view list
  await quickFilterStore.setQuickFilterItemsAsync();

  // Get and set shared link data if the linkId is present in the query params
  const linkId = to.query?.link as string;  
  if (linkId) {
    await filterStore.setSharedLinkFilterAsync(linkId);
    // Get viewId from shared link or use default
    viewId = filterStore.sharedLinkFilter?.quickFilterId || DEFAULT_FILTER_STATE.id;
    quickFilterStore.setSelectedQuickFilterById(viewId, false);
  }

  return;
});